module.exports = __webpack_public_path__ + "img/UI_suofang_icon_02_8be103b1f.png";